import React, { PureComponent } from 'react';

import { Button } from 'components/cosmos';
import { Modal } from 'components/cosmos/v2/modal';
import Html from 'components/Html';
import { translate } from 'components/translate';
import PropTypes from 'prop-types';

import { CAMPAIGNS_STATUS, CAMPAIGN_MODAL_PROPS } from '../../constants';

import './CampaignModal.scss';

@translate()
class CampaignModal extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    onConfirm: PropTypes.func,
    onClose: PropTypes.func,
    name: PropTypes.string,
    status: PropTypes.string
  };

  constructor(props) {
    super(props);

    const { status } = this.props;

    this.modalProps =
      CAMPAIGN_MODAL_PROPS[status] ||
      CAMPAIGN_MODAL_PROPS[CAMPAIGNS_STATUS.ENABLED];
  }

  render() {
    const { t, name, onConfirm, onClose } = this.props;
    const { title, description, confirmLabel } = this.modalProps;

    return (
      <Modal show onClose={onClose}>
        <Modal.Header>
          <h2>{t(title)}</h2>
        </Modal.Header>
        <Modal.Body>
          <Html>{t(description, { name })}</Html>
        </Modal.Body>
        <Modal.Footer className="_d-flex _justify-content-lg-end">
          <Button variation="default" onClick={onClose}>
            {t('general.cancel')}
          </Button>
          <Button variation="primary" className="_ml-2" onClick={onConfirm}>
            {t(confirmLabel)}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default CampaignModal;
